import React, { useEffect, useState } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import './inicio.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
import { carouselImages } from '../../json/carouselImages';

// =================================================================
// 🚨 CONFIGURACIÓN CENTRALIZADA DE POPUPS (MANTENIMIENTO)
// =================================================================
const POPUP_SEQUENCE = [
    
    {   
        image: '/assets/imgs/comparecencia2026.jpg',
        title: 'Comparecencia Secretaria de Turismo 2026',
        description: 'Elizabeth Quintanar Gómez ',
        linkUrl: 'https://www.facebook.com/share/v/1HYRJHyNjz/',
        linkText: 'Revivela aquí'
        
    },{   
        image: '/assets/imgs/2lluvia.png',
        title: 'Prevención de EDA´s  en Temperaturas Extremas y Temporada de Lluvias',
        description: 'Enfermedades Diarreicas Agudas EDAS ',
        linkUrl: '',
        linkText: ''
        
    },/*
    {
        image: '/assets/imgs/transp2026.jpg',
        title: 'Concurso Nacional de Transparencia en corto 2026',
        description: 'Tema: Desinformación: Riesgos de la IA',
        linkUrl: 'https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf',
        linkText: 'convocatoria'
    },*/
    {
        image: '/assets/imgs/huella.jpg',
        title: 'Huella de Carbono',
        description: 'Cambia tu huella, cambia Hidalgo.',
        linkUrl: '',
        linkText: ''
    },/*
    {   
        image: '/assets/imgs/ubi26.png',
        title: '¡Conoce nuestra nueva ubicación!',
        description: 'Enero 2026',
        linkUrl: '',
        linkText: ''
        
    },*/
    // Ejemplo de un TERCER POPUP (descomentar (/*, */ ) para activarlo)
   /*
    {
        image: 'https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Turismo.svg',
        title: 'Tercer Mensaje Importante',
        description: 'Revisa nuestra sección de noticias para estar al día con los eventos turísticos de Hidalgo.',
        linkUrl: '/UltimasNoticias',
        linkText: 'Ir a Últimas Noticias'
    }
    */
];
// =================================================================


// --- COMPONENTE: ImagePopup (Modal) - Ligeramente modificado para ser más limpio ---
const ImagePopup = ({ isOpen, content, onClose }) => {
    // Si no está abierto o no tiene contenido, no renderizar nada
    if (!isOpen || !content) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close-button" onClick={onClose}>×</button>
                
                {content.title && <h2>{content.title}</h2>}
                
                {content.image && (
                    <img src={content.image} alt={content.description || "Imagen Popup"} className="modal-image" />
                )}
                
                {content.description && <p className="modal-description">{content.description}</p>}

                {content.linkUrl && (
                    <div className="popup-link-container">
                        {/* Usamos Link de react-router-dom si es una ruta interna, sino un <a> normal */}
                        <Link 
                            to={content.linkUrl} 
                            className="popup-more-info-link"
                            onClick={onClose} // Cerrar el modal al navegar
                        >
                            {content.linkText || "Ver más información"}
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};
// ---------------------------------------------------


const Inicio = () => {
    // Estado único: 0 = cerrado, 1 = Popup 1 activo, 2 = Popup 2 activo, etc.
    const [currentPopupIndex, setCurrentPopupIndex] = useState(0);

    // Función para cerrar el popup y pasar al siguiente
    const closePopup = () => {
        const nextIndex = currentPopupIndex + 1;

        if (nextIndex <= POPUP_SEQUENCE.length) {
            // Si hay un siguiente popup, actualiza el índice
            setCurrentPopupIndex(nextIndex);
        } else {
            // Si no hay más popups, cierra la secuencia
            setCurrentPopupIndex(0);
        }
    };

    // --- LÓGICA CLAVE: Iniciar la secuencia al montar (siempre) ---
    useEffect(() => {
        window.scrollTo(0, 0);

        // Si la configuración tiene popups, iniciamos la secuencia en el índice 1
        if (POPUP_SEQUENCE.length > 0) {
            setCurrentPopupIndex(1);
        }
    }, []); 

    // Obtener el contenido del popup actualmente activo
    // Restamos 1 porque el índice del array es base 0, pero el estado es base 1
    const currentContent = POPUP_SEQUENCE[currentPopupIndex - 1];

    return (
        <>
            {/* 1. Renderizar un ÚNICO ImagePopup que usa el contenido dinámico */}
            <ImagePopup 
                isOpen={currentPopupIndex > 0} 
                content={currentContent} 
                onClose={closePopup} 
            />

            {/* El resto del componente de página permanece sin cambios */}
            <Carousel bannerData={carouselImages} serch={true} name={'banner-principal'} />
            <div className='container'>
                <div className='row'>
                    <div className="col-12">
                        <div className='secretaria_logo' >
                            <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Turismo.svg")` }}>
                            </div>
                        </div>
                        <div className='secretaria_name'>
                            <h1>SECRETARÍA DE TURISMO</h1>
                        </div>
                        <div className='secretaria_funciones'>
                            <h3 className='title'>FUNCIONES</h3>
                            <hr className='hr-gob' />
                            <p>Fortalecer la actividad turística generando políticas para el desarrollo del sector turismo vinculado a la riqueza patrimonial y gastronómica del
                                estado de Hidalgo las cuales tengan una visión de largo plazo con beneficios perceptibles, la gestión ambiental responsable y el respeto a la multiculturalidad y tradiciones locales.</p>
                            <Link className='ver-mas' to="/funciones">Ver más</Link>

                            <div className='btn_organigrama'>
                                <a href='/Transparencia/Rubros/DetalleRubro/2.Estructura'>Organigrama</a>
                                <a href='/Transparencia/Rubros/DetalleRubro/1.Normatividad'>Normatividad</a>
                            </div>
                            <div className='secretaria-redes'>
                                <a href='https://www.facebook.com/SECTURHidalgo?mibextid=LQQJ4d'><i className="fa-brands fa-facebook-f"></i></a>
                                <a href='https://www.instagram.com/sectur_hgo/profilecard/?igsh=OHU2NHV2NW1pNGdk'><i className="fa-brands fa-instagram"></i></a>
                                <a href='https://x.com/secturhidalgo?s=11&t=O4QnxjlVaO29NpSUDMGm7g'><i className="fa-brands fa-twitter"></i></a>
                            </div>
                        </div>
                    </div>
                </div>

                <UltimasNoticias />
                <div className='row'>
                    <div className='notes_title'>

                        <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
                        <hr className='hr-gob' />
                    </div>
                    <div className='section_notes'>
                        {
                            titular.map((item, index) => (
                                <React.Fragment key={index}>
                                    <div className='sec_photo'>
                                        <div 
                                            className='img_secretario' 
                                            style={{ backgroundImage: `url("${item.imagen}")` }}
                                        >
                                        </div>
                                    </div>
                                    <div className='sec_container'>
                                        <div className='sec_name'>
                                            <h3>{item.nombre}</h3>
                                        </div>
                                        <div className='sec_function'>
                                            <h4>Función de la Secretaria</h4>
                                            <p>{item.funcion}</p>
                                            <div className='btn_agenda'>
                                                <Link to="Agenda">Conoce la agenda de la Secretaria</Link>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))
                        }
                    </div>
                </div>


                <div className='row'>
                    <div className='section_map'>
                        <div className='map_name'>
                            <h3 className='title'>UBICACIÓN</h3>
                            <hr className='hr-gob' />
                        </div>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1873.444642960168!2d-98.77695176095395!3d20.09691445755763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1a091218a61a1%3A0x7a92106dcc1dec97!2sSecretaria%20Real%20de%20La%20Plata%20301%2C%20Zona%20Plateada%2C%2042084%20Pachuca%20de%20Soto%2C%20Hgo.!5e0!3m2!1ses!2smx!4v1768511263335!5m2!1ses!2smx" 
                            width="100%"
                            height="300"
                            frameBorder="0"
                            style={{ border: 0, marginBottom: 50 }}
                            allowFullScreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Inicio